import React, { useState, useEffect } from "react";
import moment from "moment";
import { useFormik } from "formik";
import * as yup from "yup";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Modal, Button, Image, Form } from "react-bootstrap";
import {
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { AddFlagReason } from "../../../../enums/DropDownDataTable";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import isEmpty from "../../../../store/validation/is-Empty";
import {
  admin_update_flag_block_merchant,
  get_all_admin_active_vendors,
} from "../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";

export const SuperAdminFlag = (props) => {
  let dispatch = useDispatch();
  let history = useHistory();
  const [showFlag, seShowFlag] = useState(false);
  const [flag, setFlag] = useState(false);
  const handleCloseFlag = () => seShowFlag(false);
  const handleShowFlag = () => seShowFlag(true);

  /************************************
   * @DESC Reason for Flagging a User
   ***********************************/
  const [showReasonPopup, setReasonPopup] = useState(false);
  const reasonPopupClose = () => {
    setReasonPopup(false);
    seShowFlag(false);
  };
  const reasonPopupShow = () => {
    setReasonPopup(true);
    seShowFlag(false);
  };

  const onFlagClick = (e) => {
    const vendor_id = props.data.vendor_id;
    const token = props.auth.user.accessToken;
    const formData = {
      flagged: !flag,
    };
    dispatch(
      admin_update_flag_block_merchant(formData, vendor_id, token, callback)
    );
  };

  const callback = (e) => {
    reasonPopupClose();
    Alert.success(
      `<h4>Vendor ${
        props.data && props.data.vendor && props.data.vendor.flagged
          ? "Unflag"
          : "Flag"
      } Successfully </h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
    formik.setFieldValue("reason", "");
    formik.setFieldValue("comment", "");
    props.get_all_admin_active_vendors(
      props.auth.user.accessToken,
      true,
      moment().format(props?.dataFilterData?.startDate),
      moment().format(props?.dataFilterData?.endDate)
    );
    if (props.actionCall === "pending") {
      history.push("/superadminallpendingvendors");
    } else if (props.actionCall === "active") {
      history.push("/superadminallvendors");
    } else {
      return null;
    }
  };

  useEffect(() => {
    setFlag(props?.data && props?.data?.vendor && props?.data?.vendor?.flagged);
  }, [props.data]);

  const formik = useFormik({
    initialValues: {
      vendor_id: "",
      reason: "",
      comment: "",
    },
    validationSchema: yup.object({
      reason: yup.string().required("Reason is required"),
      comment: yup.string().max(150, "Minimum 150 Character"),
      // .max(150, "Maximum 150 Character"),
    }),

    onSubmit: (values) => {
      var formData = {};
      formData.reason = values.reason;
      formData.comment = values.comment;
      formData.flagged = !flag;
      const vendor_id = props.data.vendor_id;
      const token = props.auth.user.accessToken;
      dispatch(
        admin_update_flag_block_merchant(formData, vendor_id, token, callback)
      );
    },
  });

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    formik.setFieldValue("reason", "");
  }, []);
  // for set focus
  useEffect(() => {
    if (formik.errors && formik.errors.reason) {
      let reasonElement = document.getElementById("reason");
      reasonElement.focus();
    }
  }, [count]);

  return (
    <React.Fragment>
      <Button
        variant="link"
        className={`${
          props.data && props.data.vendor && props.data.vendor.flagged
            ? "border-0 enIconBtn mr-3"
            : "enIconBtn mr-3"
        }`}
        onClick={handleShowFlag}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/flag.svg")}
          alt="Flag User"
          title="Flag User"
          fluid
        />
      </Button>
      <Modal show={showFlag} onHide={handleCloseFlag} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="f24-700">Flag Merchant</Modal.Title>
        </Modal.Header>
        <Modal.Body className="f14-500">
          Are you sure to {flag ? "Unflag" : "Flag"} the merchant ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseFlag}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            // onClick={onFlagClick}
            onClick={reasonPopupShow}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showReasonPopup} onHide={reasonPopupClose} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title className="f24-700">
            Reason for Flagging a User
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          <Form noValidate>
            <div className="mb-3">
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Select Reason
                </InputLabel>
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="reason"
                  name="reason"
                  value={formik.values.reason}
                  onChange={formik.handleChange}
                  label="Select Reason"
                  IconComponent={KeyboardArrowDownIcon}
                >
                  <MenuItem value="" disabled selected>
                    Select Reason
                  </MenuItem>
                  {AddFlagReason &&
                    AddFlagReason.map((item, index) => {
                      return (
                        <MenuItem key={index} value={item.value}>
                          {item.title}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
              {formik.errors.reason && formik.touched.reason ? (
                <div className="f11-400 pt-1 text-danger">
                  {formik.errors.reason}
                </div>
              ) : null}
            </div>
            <TextField
              id="comment"
              label="Add Comments"
              type="text"
              multiline
              rows="5"
              variant="outlined"
              className={`w-100 ${
                formik.errors.comment && formik.touched.comment ? "enError" : ""
              }`}
              name="comment"
              onChange={formik.handleChange}
              value={formik.values.comment}
              onBlur={formik.handleBlur}
            />
            {formik.errors.comment && formik.touched.comment ? (
              <div className="f11-400 pt-1 text-danger">
                {formik.errors.comment}
              </div>
            ) : (
              <div className="f11-400 opacity5 pt-1">
                Maximum 150 Characters*
              </div>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={reasonPopupClose}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            // onClick={onFlagClick}
            onClick={() => onClickSave()}
          >
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

SuperAdminFlag.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  dataFilterData: state.adminAllVendorsInfo.filter_date_value,
});

export default connect(mapStateToProps, {
  admin_update_flag_block_merchant,
  get_all_admin_active_vendors,
})(withRouter(SuperAdminFlag));
